















import { Component, Prop } from 'vue-property-decorator'
import { BaseInput, ICampoTemplate } from './base/BaseInput'

@Component({
  name: 'InputNumber'
})
export default class InputNumber extends BaseInput {
  @Prop({ required: true })
  campo!: ICampoTemplate
}
